import { convexQuery } from '@convex-dev/react-query'
import { api } from '@cvx/_generated/api'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigation } from '@/features/dashboard/components/navigation'
import { OrgRagChatPanel } from '@/features/dashboard/components/org-rag-chat-panel'
import { Header } from '@/shared/ui/header'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout')({
  component: DashboardLayout,
})

const LOCKED_STATUSES = new Set(['canceled', 'past_due', 'none'])

function DashboardLayout() {
  const { t } = useTranslation()
  const [isChatOpen, setIsChatOpen] = useState(false)
  const { data: user } = useQuery(
    convexQuery(api.features.user.user.getMyCurrentUser, {}),
  )
  if (!user) {
    return null
  }

  const isAccountLocked =
    !user.subscription || LOCKED_STATUSES.has(user.subscription.status)

  return (
    <div className="flex min-h-screen w-full flex-col bg-secondary dark:bg-black">
      <Navigation
        user={user}
        isChatOpen={isChatOpen}
        onChatToggle={() => setIsChatOpen((prev) => !prev)}
      />
      {isAccountLocked && (
        <div className="flex items-center justify-between gap-4 bg-destructive/10 px-6 py-3 text-sm text-destructive">
          <p>{t('dashboard.accountLocked.message')}</p>
          <Link
            to="/dashboard/settings/billing"
            className="shrink-0 font-medium underline underline-offset-4"
          >
            {t('dashboard.accountLocked.reactivate')}
          </Link>
        </div>
      )}
      <Header />
      <div className="flex flex-1">
        <div className="flex flex-1 flex-col min-w-0">
          <Outlet />
        </div>
        {isChatOpen && (
          <div className="hidden w-80 shrink-0 lg:flex flex-col border-l border-border sticky top-[var(--nav-height,112px)] h-[calc(100vh-var(--nav-height,112px))]">
            <OrgRagChatPanel onClose={() => setIsChatOpen(false)} />
          </div>
        )}
      </div>
    </div>
  )
}
